class Action {
  actions = {
    onGlobalStateChange: () => {},
    setGlobalState: () => {},
  };

  setAction(actions) {
    this.actions = actions;
  }
  onGlobalStateChange(...args) {
    return this.actions.onGlobalStateChange(...args);
  }

  setGlobalState(...args) {
    return this.actions.setGlobalState(...args);
  }
}

const actions = new Action();

export default actions;
